import { type WorkspaceAgentMentionRowItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';

const WORKSPACE_AGENT_SELECT_ASSET_OPTION_ID_PREFIX = 'workspace-agent-select-asset-option-';

export const getWorkspaceAgentSelectAssetOptionId = (itemId: string) =>
  `${WORKSPACE_AGENT_SELECT_ASSET_OPTION_ID_PREFIX}${itemId}`;

export const getWorkspaceAgentSelectAssetActiveOptionId = (
  items: readonly WorkspaceAgentMentionRowItem[],
  highlightedIndex: number,
) => {
  if (items.length === 0) {
    return undefined;
  }

  const item = items[Math.min(highlightedIndex, items.length - 1)];

  return item ? getWorkspaceAgentSelectAssetOptionId(item.id) : undefined;
};
